import { config } from "./config";
import { carryParams } from "./utils";


export const redirectToOnboardingCheckout = () => {
  const url = new URL(config.onboarding.baseUrl);
  const onboardingPageBaseUrl = url.origin + '/onboarding';
  const redirectUrl = carryParams(onboardingPageBaseUrl, {
    src: 'vo-demo',
  });
  window.open(redirectUrl, '_blank');
};
